import { IRegex } from '../stores/lookUpStore'

import axiosAuth from './axiosAuth'

export const getRegexes = (controller: AbortController) =>
    axiosAuth.get<IRegex[]>('/regexes', {
        signal: controller.signal,
    })

export const putRegex = (regex: IRegex) =>
    axiosAuth.put(`/regexes/${regex._id}`, regex)

export const postRegex = (newRegex: { name: string; pattern: string }) =>
    axiosAuth.post('/regexes', newRegex)

export const deleteRegex = (id: string) => axiosAuth.delete(`/regexes/${id}`)
